import { Component, Input, OnInit } from '@angular/core';
import { RoutingService } from '@spartacus/core';
import { CustomOrderHistory, CustomOrderHistoryEntry } from '../../../custom-order-history.models';

@Component({
    selector: 'app-custom-order-history-overview-table-remains',
    templateUrl: './custom-order-history-overview-table-remains.component.html',
    standalone: false
})
export class CustomOrderHistoryOverviewTableRemainsComponent implements OnInit {

  @Input() entries: CustomOrderHistoryEntry[];

  constructor(
    protected routing: RoutingService,
  ) {}

  ngOnInit(): void {
  }

  goToOrderDetail(order: CustomOrderHistory): void {
    this.routing.go({
      cxRoute: 'orderDetails',
      params: order,
    });
  }

}
